module.exports = __webpack_public_path__ + "img/corteva.0f6bc772.svg";